<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'RoutingOSPFList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Routing OSPF
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Routing OSPF</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="RoutingOSPF">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-sm">
                      <label class="control-label">Default Information Originated</label>
                      <div class="d-flex align-items-center mt-1">
                        <label class="radio mr-3">
                          <input
                            type="radio"
                            id="defaultInfo_enable"
                            name="defaultInfo_enable"
                            v-model="value.defaultInfo_enable"
                            class=""
                            value="1"
                          />
                          <span class="radio-mark"></span>
                          Yes
                        </label>
                        <label class="radio">
                          <input
                            type="radio"
                            id="defaultInfo_enable"
                            name="defaultInfo_enable"
                            v-model="value.defaultInfo_enable"
                            class=""
                            value="0"
                          />
                          <span class="radio-mark"></span>
                          No
                        </label>
                      </div>
                      <div
                        class="help text-danger"
                        v-show="errors.has('defaultInfo_enable')"
                      >
                        {{ errors.first("defaultInfo_enable") }}
                      </div>
                    </div>
                    <div v-if="organizationId == 1" class="form-group col-sm required">
                      <label class="control-label">Audra Name</label>
                      <input
                        v-if="is_edit"
                        v-model="pre.audraName[value.accountId]"
                        id="accountId"
                        name="accountId"
                        class="form-control accountId"
                        readonly
                      />
                      <multiselect
                        v-else
                        v-model="value.accountId"
                        :options="Object.keys(pre.audraName)"
                        :custom-label="(opt) => pre.audraName[opt]"
                        placeholder="Select Audra Name"
                        :searchable="true"
                        :multiple="false"
                        id="accountId"
                        v-bind:class="{ 'has-error': errors.has('accountId') }"
                        v-validate="'required'"
                        name="accountId"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('accountId')">
                        {{ errors.first("accountId") }}
                      </div>
                    </div>

                    <div class="form-group col-sm required">
                      <label class="control-label">Router ID</label>
                      <input
                        type="text"
                        id="router_id"
                        name="router_id"
                        :readonly="is_edit"
                        v-bind:class="{ 'has-error': errors.has('router_id') }"
                        v-validate="'required|ip'"
                        v-model="value.router_id"
                        class="form-control router_id"
                        placeholder="Router ID"
                      />
                      <div class="help text-danger" v-show="errors.has('router_id')">
                        {{ errors.first("router_id") }}
                      </div>
                    </div>

                    <!-- <div class="form-group">
                    <label class="control-label"
                      >Default Information Originated</label
                    >
                    <br />
                    <input
                      type="radio"
                      id="defaultInfo_enable"
                      name="defaultInfo_enable"
                      v-model="value.defaultInfo_enable"
                      class=""
                      value="1"
                    />Yes
                    <input
                      type="radio"
                      id="defaultInfo_enable"
                      name="defaultInfo_enable"
                      v-model="value.defaultInfo_enable"
                      class=""
                      value="0"
                    />No
                    <div
                      class="help text-danger"
                      v-show="errors.has('defaultInfo_enable')"
                    >
                      {{ errors.first("defaultInfo_enable") }}
                    </div>
                  </div> -->

                    <div class="form-group col-sm">
                      <label class="control-label">Distance</label>
                      <input
                        type="text"
                        id="distance"
                        name="distance"
                        :readonly="is_edit"
                        v-validate="{ regex: /^\d+$/ }"
                        v-bind:class="{ 'has-error': errors.has('distance') }"
                        v-model="value.distance"
                        class="form-control distance"
                        placeholder="Distance"
                      />
                      <div class="help text-danger" v-show="errors.has('distance')">
                        {{ errors.first("distance") }}
                      </div>
                    </div>
                  </div>

                  <div class="w-full mt-3 p-10">
                    <h4
                      class="card-common-title p-0 mb-2"
                      :class="{
                        'pb-2 border-bottom': !networkAreas.length > 0,
                      }"
                    >
                      Network
                    </h4>
                    <div
                      v-for="(networkArea, index) in networkAreas"
                      :key="index"
                      class=""
                    >
                      <div class="form-row">
                        <div class="form-group col-sm">
                          <label class="control-label">Area ID</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="networkArea.area_id"
                            v-validate="'required'"
                            :options="Object.keys(pre.areaIds)"
                            :custom-label="(opt) => pre.areaIds[opt]"
                            placeholder="Select Area ID"
                            :searchable="true"
                            :multiple="false"
                            id="area_id"
                            v-bind:class="{
                              'has-error': errors.has('area_id'),
                            }"
                            name="area_id"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('area_id')">
                            {{ errors.first("area_id") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Network Address</label>
                          <input
                            type="text"
                            id="network_address"
                            name="network_address"
                            v-validate.lazy="'required|ip_CIDR'"
                            v-bind:class="{
                              'has-error': errors.has('network_address'),
                            }"
                            v-model="networkArea.network_address"
                            class="form-control network_address"
                            placeholder="Example : 192.168.20.0/24"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('network_address')"
                          >
                            {{ errors.first("network_address") }}
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a class="text-danger fw-500" @click="removeNetworkArea(index)">
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div class="form-group text-right">
                      <a @click.prevent="addMoreNetworkArea()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>

                  <!-- Interface -->
                  <div class="w-full mt-3 p-10">
                    <h4
                      class="card-common-title p-0 mb-2"
                      :class="{
                        'pb-2 border-bottom': !interfaces.length > 0,
                      }"
                    >
                      Interfaces
                    </h4>
                    <div v-for="(interfce, index) in interfaces" :key="index" class="">
                      <div class="form-row">
                        <div class="form-group col-sm">
                          <label class="control-label">Name</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="interfce.name"
                            v-validate="'required'"
                            :options="Object.keys(pre.interfaceNames)"
                            :custom-label="(opt) => pre.interfaceNames[opt]"
                            placeholder="Select Name"
                            :searchable="true"
                            :multiple="false"
                            id="name"
                            v-bind:class="{ 'has-error': errors.has('name') }"
                            name="name"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('name')">
                            {{ errors.first("name") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Type</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="interfce.type"
                            v-validate="'required'"
                            :options="Object.keys(pre.interfaceType)"
                            :custom-label="(opt) => pre.interfaceType[opt]"
                            placeholder="Select Type"
                            :searchable="true"
                            :multiple="false"
                            id="type"
                            v-bind:class="{ 'has-error': errors.has('type') }"
                            name="type"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('type')">
                            {{ errors.first("type") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Cost</label>
                          <input
                            type="text"
                            id="cost"
                            name="cost"
                            v-bind:class="{ 'has-error': errors.has('cost') }"
                            v-model="interfce.cost"
                            class="form-control cost"
                            placeholder="Input Cost"
                          />
                          <div class="help text-danger" v-show="errors.has('cost')">
                            {{ errors.first("cost") }}
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a class="text-danger fw-500" @click="removeInterface(index)">
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div class="form-group text-right">
                      <a @click.prevent="addMoreInterface()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>

                  <!-- Area Properties -->
                  <div class="w-full mt-3 p-10">
                    <h4
                      class="card-common-title p-0 mb-2"
                      :class="{
                        'pb-2 border-bottom': !areaProperties.length > 0,
                      }"
                    >
                      Area Properties
                    </h4>
                    <div
                      v-for="(areaProperty, index) in areaProperties"
                      :key="index"
                      class=""
                    >
                      <div class="form-row">
                        <div class="form-group col-sm">
                          <label class="control-label">Area ID</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="areaProperty.area_id"
                            :options="Object.keys(pre.areaIds)"
                            :custom-label="(opt) => pre.areaIds[opt]"
                            v-validate="'required'"
                            placeholder="Select Area ID"
                            :searchable="true"
                            :multiple="false"
                            id="area_id"
                            v-bind:class="{
                              'has-error': errors.has('area_id'),
                            }"
                            name="area_id"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('area_id')">
                            {{ errors.first("area_id") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Properties</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="areaProperty.prop_name"
                            @input="setAreaFields"
                            :options="Object.keys(pre.properties)"
                            :custom-label="(opt) => pre.properties[opt]"
                            placeholder="Select Properties"
                            :searchable="true"
                            :multiple="false"
                            id="prop_name"
                            v-bind:class="{
                              'has-error': errors.has('prop_name'),
                            }"
                            name="prop_name"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('prop_name')">
                            {{ errors.first("prop_name") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Value</label>

                          <input
                            v-if="
                              areaProperty.prop_name == 'virtual-link' ||
                              areaProperty.prop_name == 'range'
                            "
                            type="text"
                            id="prop_value"
                            name="prop_value"
                            v-bind:class="{
                              'has-error': errors.has('prop_value'),
                            }"
                            v-model="areaProperty.prop_value"
                            class="form-control prop_value"
                            :placeholder="areaValuePlaceholder"
                          />

                          <multiselect
                            v-else
                            :select-label="''"
                            :deselect-label="''"
                            v-model="areaProperty.prop_value"
                            :options="pre.propValues"
                            placeholder="Select Value"
                            :searchable="true"
                            :multiple="false"
                            id="prop_value"
                            v-bind:class="{
                              'has-error': errors.has('prop_value'),
                            }"
                            name="prop_value"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('prop_value')">
                            {{ errors.first("prop_value") }}
                          </div>
                        </div>

                        <div
                          v-show="areaProperty.prop_name === 'filter-list prefix'"
                          class="form-group col-sm"
                        >
                          <label class="control-label">Direction</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="areaProperty.direction"
                            :options="Object.keys(pre.propertyDirection)"
                            :custom-label="(opt) => pre.propertyDirection[opt]"
                            placeholder="Select Type"
                            :searchable="true"
                            :multiple="false"
                            id="direction"
                            v-bind:class="{
                              'has-error': errors.has('direction'),
                            }"
                            name="direction"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('direction')">
                            {{ errors.first("direction") }}
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a class="text-danger fw-500" @click="removeAreaProperty(index)">
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div class="form-group text-right">
                      <a @click.prevent="addMoreAreaProperty()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>

                  <!-- Authentication -->
                  <div style="display: none" class="w-full mt-3 p-10">
                    <h4
                      class="card-common-title p-0 mb-2"
                      :class="{
                        'pb-2 border-bottom': !authentications.length > 0,
                      }"
                    >
                      Authentication
                    </h4>
                    <div
                      v-for="(authentication, index) in authentications"
                      :key="index"
                      class=""
                    >
                      <div class="form-row">
                        <div class="form-group col-sm">
                          <label class="control-label">Area ID</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="authentication.area_id"
                            v-validate="'required'"
                            :options="Object.keys(pre.areaIds)"
                            :custom-label="(opt) => pre.areaIds[opt]"
                            placeholder="Select Area ID"
                            :searchable="true"
                            :multiple="false"
                            id="area_id"
                            v-bind:class="{
                              'has-error': errors.has('area_id'),
                            }"
                            name="area_id"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('area_id')">
                            {{ errors.first("area_id") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Type</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="authentication.type"
                            v-validate="'required'"
                            :options="Object.keys(pre.authenticationType)"
                            :custom-label="(opt) => pre.authenticationType[opt]"
                            placeholder="Select Type"
                            :searchable="true"
                            :multiple="false"
                            id="authenticationType"
                            v-bind:class="{
                              'has-error': errors.has('authenticationType'),
                            }"
                            name="authenticationType"
                          >
                          </multiselect>
                          <div
                            class="help text-danger"
                            v-show="errors.has('authenticationType')"
                          >
                            {{ errors.first("authenticationType") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Interface</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="authentication.interface"
                            :options="pre.interfaceDescription"
                            placeholder="Select Interface"
                            :searchable="true"
                            :multiple="false"
                            id="authenticationInterface"
                            v-bind:class="{
                              'has-error': errors.has('authenticationInterface'),
                            }"
                            name="authenticationInterface"
                          >
                          </multiselect>
                          <div
                            class="help text-danger"
                            v-show="errors.has('authenticationInterface')"
                          >
                            {{ errors.first("authenticationInterface") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="control-label">Key</label>
                          <input
                            type="text"
                            id="authenticationKey"
                            name="authenticationKey"
                            v-bind:class="{
                              'has-error': errors.has('authenticationKey'),
                            }"
                            v-model="authentication.key"
                            class="form-control authenticationKey"
                            placeholder="Input Key"
                          />

                          <div
                            class="help text-danger"
                            v-show="errors.has('authenticationKey')"
                          >
                            {{ errors.first("authenticationKey") }}
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a
                          class="text-danger fw-500"
                          @click="removeAuthentication(index)"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div class="form-group text-right">
                      <a @click.prevent="addMoreAuthentication()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>

                  <!-- Redistribute -->
                  <div class="w-full mt-4 p-10">
                    <h4
                      class="card-common-title p-0 mb-2"
                      :class="{
                        'pb-2 border-bottom': !redistributes.length > 0,
                      }"
                    >
                      Redistribute
                    </h4>
                    <div
                      v-for="(redistribute, index) in redistributes"
                      :key="index"
                      class=""
                    >
                      <div class="form-row align-items-end mb-3">
                        <div class="col-8">
                          <label class="control-label">Redistribute</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="redistribute.redistributes"
                            :options="Object.keys(pre.redistributes)"
                            :custom-label="(opt) => pre.redistributes[opt]"
                            placeholder="Select Redistribute"
                            :searchable="true"
                            :multiple="false"
                            id="redistribute"
                            v-bind:class="{
                              'has-error': errors.has('redistribute'),
                            }"
                            name="redistribute"
                          >
                          </multiselect>
                          <div
                            class="help text-danger"
                            v-show="errors.has('redistribute')"
                          >
                            {{ errors.first("redistribute") }}
                          </div>
                        </div>
                        <div class="col-4 mb-2">
                          <a
                            class="text-danger fw-500 mt-2"
                            @click="removeRedistribute(index)"
                          >
                            <i class="icon-trash"></i> Remove
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class=""
                        :class="{
                          'col-md-8': redistributes.length > 0,
                          'col-md-12': redistributes.length === 0,
                        }"
                      >
                        <div class="form-group text-right pt-2">
                          <a @click.prevent="addMoreRedistribute()" class="pc fw-500">
                            <i class="fas fa-plus-circle"></i> New
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "RoutingOSPFForm",
  metaInfo: {
    title: "Routing OSPF | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      audraName: [],
      areaIds: [],
      interfaceNames: [],
      interfaceType: {
        broadcast: "BROADCAST",
        "non-broadcast": "NON BROADCAST",
        "point-to-multipoint": "POINT TO MULTIPOINT",
        "point-to-point": "POINT TO POINT",
      },
      properties: {
        "export-list": "EXPORT LIST",
        "import-list": "IMPORT LIST",
        "filter-list prefix": "PREFIX LIST",
        stub: "STUB",
        "stub no-summary": "STUB NO-SUMMARY",
        nssa: "NSSA",
        "nssa suppress-fa": "NSSA SUPPRESS-FA",
        "virtual-link": "VIRTUAL LINK",
        "default-cost": "DEFAULT COST",
        range: "RANGE",
      },
      propValues: [],
      propertyDirection: { in: "IN", out: "OUT" },
      authenticationType: {
        "key-chain": "KEY CHAIN",
        "message-digest": "MESSAGE DIGEST",
      },
      redistributes: { bgp: "BGP", connected: "CONNECTED", static: "STATIC" },
      interfaceDescription: [],
    },
    networkAreas: [],
    interfaces: [],
    areaProperties: [],
    authentications: [],
    redistributes: [],
    areaValuePlaceholder: "",
  }),

  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          this.setSubmitValue();
          let api_url = "/routing_ospf";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/routing_ospf/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "RoutingOSPFList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/routing_ospf/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getAreaIds: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-area-ids", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getInterfaceDescriptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-interface-descriptions", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getInterfaceNames: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-interface-names", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async getAreaValues(propName) {
      return new Promise((resolve, reject) => {
        axios
          .get("get-area-values", {
            params: {
              accountId: LocalStorage.get("accountId"),
              prop_name: propName,
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.setFormValue();
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.defaultInfo_enable = 0;
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getAreaIds()
        .then((response) => {
          this.pre.areaIds = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getInterfaceNames()
        .then((response) => {
          this.pre.interfaceNames = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getInterfaceDescriptions()
        .then((response) => {
          this.pre.interfaceDescription = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
      this.setCustomValidation();
    },
    addMoreNetworkArea() {
      this.networkAreas.push({
        area_id: "",
        network_address: "",
      });
    },
    removeNetworkArea(index) {
      this.networkAreas.splice(index, 1);
    },
    addMoreInterface() {
      this.interfaces.push({
        name: "",
        type: "",
        cost: "",
      });
    },
    removeInterface(index) {
      this.interfaces.splice(index, 1);
    },
    addMoreAreaProperty() {
      this.areaProperties.push({
        area_id: "",
        prop_name: "",
        prop_value: "",
        direction: "",
      });
    },
    removeAreaProperty(index) {
      this.areaProperties.splice(index, 1);
    },
    addMoreAuthentication() {
      this.authentications.push({
        area_id: "",
        type: "",
        interface: "",
        key: "",
      });
    },
    removeAuthentication(index) {
      this.authentications.splice(index, 1);
    },
    addMoreRedistribute() {
      this.redistributes.push({
        redistributes: "",
      });
    },
    removeRedistribute(index) {
      this.redistributes.splice(index, 1);
    },
    setSubmitValue() {
      this.value.network_area = this.networkAreas;
      this.value.area = this.areaProperties;
      this.value.interfaces = this.interfaces;
      this.value.authetication = this.authentications;
      this.value.redistribute = this.redistributes;
    },
    setFormValue() {
      this.networkAreas = this.value.network_area;
      this.areaProperties = this.value.area;
      this.interfaces = this.value.interfaces;
      this.authentications = this.value.authetication;
      this.redistributes = this.value.redistribute;
    },

    async setAreaFields(event) {
      this.pre.propValues = [];
      if (event === "range") {
        this.areaValuePlaceholder = "192.168.20.0/24";
      } else if (event === "virtual-link") {
        this.areaValuePlaceholder = "Remote RID";
      }

      if (
        event === "export-list" ||
        event === "import-list" ||
        event === "filter-list prefix"
      ) {
        await this.getAreaValues(event)
          .then((response) => {
            this.pre.propValues = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      } else {
        this.pre.propValues = [
          "no-summary",
          "translate-always",
          "translate-candidate",
          "translate-never",
        ];
      }
    },
    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? 1 : 0;
        },
      });
    },

    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style>
input {
  flex: 1;
  padding: 5px;
  padding-left: 5px;
  box-sizing: border-box;
}

.container {
  margin-top: 100px;
}

.duplicate-row {
  margin-top: 50px;
  position: relative;
  padding-right: 70px;
}

.duplicate-row .btn-remove {
  position: absolute;
  right: 0;
  top: 30px;
  font-family: fontawesome;
}
</style>
